module.exports = __webpack_public_path__ + "static/activity_icon203f13e453d2d34044b6392fd6db5db4ac.png";